export const DS_ICONS = {
    notification: 'assets/icons/ic_notification.svg',
    info: 'assets/icons/infos.svg',
    list: 'assets/icons/list.svg',
    map: 'assets/icons/map.svg',
    markerDefault: 'assets/icons/marker-default.svg',
    markerSelected: 'assets/icons/marker-selected.svg',
    markerUnknown: 'assets/icons/marker-unknown.svg',
} as const;

export type DsIcon = keyof typeof DS_ICONS;

// Suffix of the icon-* color classes. The device icon styles all three itself; the gateway icon
// takes them from src/styles/variants.scss, which has no icon-grey.
export enum DEVICE_ICON_COLOR {
    YELLOW = 'yellow',
    WHITE = 'white',
    GREY = 'grey',
}
